@switch (mode()) {
  @case ('compact') {
    <div class="surface flex flex-col gap-2 rounded-xl p-2">
      <div class="!text-primary flex w-full flex-row gap-2">
        <mat-icon>{{ displayIcon() }}</mat-icon>
        <span class="truncate">{{ displayTitle() | siaTranslate }}</span>
      </div>
      @if (headerInformation()) {
        <div class="text-outline truncate text-sm">
          {{ headerInformation() | siaTranslate }}
        </div>
      }
      <ng-container [ngTemplateOutlet]="content"></ng-container>
      @if (footerInformation()) {
        <div class="text-outline truncate text-sm italic">
          {{ footerInformation() | siaTranslate }}
        </div>
      }
    </div>
  }
  @default {
    @if (!fullScreen()) {
      <mat-expansion-panel
        [expanded]="opened()"
        (expandedChange)="onOpenedChange($event)"
        [class]="panelClass()"
      >
        <mat-expansion-panel-header class="title text-nowrap">
          <mat-panel-title
            class="text-primary !flex-1 overflow-hidden text-ellipsis"
          >
            {{ displayTitle() | siaTranslate }}
          </mat-panel-title>
          <mat-panel-description class="flex !w-[10%] justify-end">
            @if (displayIcon()) {
              <mat-icon>{{ displayIcon() }}</mat-icon>
            }
          </mat-panel-description>
        </mat-expansion-panel-header>
        @if (headerInformation()) {
          <div class="text-outline truncate text-sm">
            {{ headerInformation() | siaTranslate }}
          </div>
        }
        <div
          class="md:surface-lowest flex h-full w-full flex-col content-center rounded-lg md:p-4"
        >
          <ng-container [ngTemplateOutlet]="content"></ng-container>
        </div>
        @if (footerInformation()) {
          <div class="text-outline truncate text-sm italic">
            {{ footerInformation() | siaTranslate }}
          </div>
        }
      </mat-expansion-panel>
    } @else {
      <ng-container [ngTemplateOutlet]="content"></ng-container>
    }
  }
}

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
